import { Icon } from "@fortawesome/fontawesome-svg-core";
import { faCog, faLifeRing } from "@fortawesome/pro-light-svg-icons";
import {
  faFolderArrowDown,
  faWandMagicSparkles,
} from "@fortawesome/pro-regular-svg-icons";
import { paths } from "~/router/paths";
import { INavItem } from "~/types/routing";
import { DISABLE_PAYMENTS } from "~/helpers/plans";

export const navItems: Array<INavItem> = [
  {
    namePath: "nav.my_stores",
    path: paths.app.home,
    icon: faFolderArrowDown as Icon,
  },
  {
    namePath: "nav.generate_store",
    path: paths.app.quiz,
    icon: faWandMagicSparkles as Icon,
  },
  {
    namePath: "settings.title",
    path: DISABLE_PAYMENTS ? paths.settings.account : paths.settings.plans,
    icon: faCog as Icon,
  },
  {
    namePath: "nav.help_center",
    path: "https://help.spocket.co/en",
    openInNewTab: true,
    icon: faLifeRing as Icon,
    // Uncomment this to show help center as a modal
    // showHelpCenterModal: true,
  },
];
